/**
 * Actual reference mobile toolbar icons (bdvegas.online #toolbar).
 * Sourced from:
 *   https://img.b100vg.com/bvg/h5/assets/images/icon-set/toolbar-icon/
 * Copied locally — no runtime hotlink.
 */
import home from './toolbar-icon-home.svg';
import promotion from './toolbar-icon-promotion.svg';
import deposit from './toolbar-icon-deposit.svg';
import mine from './toolbar-icon-mine.svg';

export const TOOLBAR_ICON_SRC = {
  home,
  promotion,
  deposit,
  mine,
};
